import React from 'react';

import { TOOL_IDS } from '@adsk/alloy-provider';
import { StampIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import { TabTitle } from '@adsk/exo-skeleton-react';

import { queryEntities, getEntitiesByIds } from './api/entities';
import {
  SubmittalsDataView,
  EntityBlock,
  EntityMenuItem,
  FiltersPanel,
  SubmittalsActivityCard,
  SearchBox,
} from './components';
import Provider from './components/Provider';
import {
  RemoveConfirmationModalTitle,
  RemoveConfirmationModalContent,
} from './components/RemoveConfirmationModal';
import { SubmittalsItem } from './types';
import ReferencePickerPlugin from '../../types/ReferencePickerPlugin';

const plugin: ReferencePickerPlugin<SubmittalsItem> = {
  metadata: {
    domain: 'autodesk-construction-submittals',
    type: 'submittalitem',
  },
  renderIcon: (p) => <StampIcon {...p} />,
  showSearchBox: true,
  toolId: TOOL_IDS.SUBMITTALS,
  is3LOSupported: true,

  PluralText: ({ lowerCase }) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
    const result = T.translate('SUBMITTALS');
    if (typeof result === 'string' && lowerCase) {
      return result.toLowerCase();
    }
    return result;
  },
  PickerModalTitle: ({ showTabTitle = true }) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
    const value = T.translate('ADD_SUBMITTALS_REFERENCE');

    return (
      <>
        {showTabTitle && <TabTitle value={value as string} />}
        {value}
      </>
    );
  },
  AddRelationshipsButtonText: ({ count }) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
    if (count === 1) {
      return T.translate('ADD_SINGLE_ITEM');
    }
    return T.translate('ADD_MULTIPLE_ITEMS');
  },
  SelectedCount: ({ count }) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
    return T.translate('SUBMITTALS_SELECTED', { count });
  },
  queryEntities,
  getEntitiesByIds: ({ ids, projectId }) => getEntitiesByIds(projectId, ids),

  // components
  CustomDataView: SubmittalsDataView,
  EntityBlock,
  EntityMenuItem,
  FiltersPanel,
  ActivityCard: SubmittalsActivityCard,
  CustomPickerSearchBox: SearchBox,

  CustomRemoveEntityModalTitle: RemoveConfirmationModalTitle,
  CustomRemoveEntityModalContent: RemoveConfirmationModalContent,

  Provider,
};

export default plugin;
